import React from 'react'; // eslint-disable-line
import i18n from '../../i18n';
import ErrorList from '../status/ErrorList';

class PublishPopover extends React.Component {
    closeDialog = () => {
        if (this.props.CloseDialog) {
            this.props.CloseDialog();
        }
    }

    onKeyDownFn = (e) => {
        if (e.keyCode === 27) {
            this.closeDialog();
        }
    }

    render() {
        const {
            Visible,
            Errors,
        } = this.props;

        return (
            // eslint-disable-next-line
            <div
                className={`publish-popover dialog-overlay ${Visible ? 'dialog-show' : 'dialog-hide'}`}
                onClick={this.closeDialog}
            >
                <div className="dialog-content">
                    <h2>{i18n.t('publish.pop-header')}</h2>
                    <p>{i18n.t('publish.pop-subtitle')}</p>
                    <ErrorList projectId={this.props.projectId} errors={Errors} pagesFlag={this.props.pagesFlag} />
                </div>
            </div>
        );
    }
}

export default PublishPopover;
